export type KeyId = string

export enum KeyTypeEnum {
  Api = 'api',
  Mcp = 'mcp',
}

export interface KeyBaseInterface {
  id: KeyId
  name: string
  createdAt: string
  maskedToken: string
  expired: boolean
  type: KeyTypeEnum
}

export interface PublicApiSettingsViewInterface extends KeyBaseInterface {
  expiresAt: string | null
  type: KeyTypeEnum.Api
}

export interface McpSettingsViewInterface extends KeyBaseInterface {
  expiresAt: string
  type: KeyTypeEnum.Mcp
}

export interface PublicApiSettingsCreatedInterface
  extends Omit<PublicApiSettingsViewInterface, 'maskedToken' | 'expired'> {
  token: string
}

export interface PublicApiSettingsCreateInterface
  extends Pick<PublicApiSettingsViewInterface, 'name'> {
  expiresAt?: string
}

export interface McpSettingsCreatedInterface
  extends Omit<McpSettingsViewInterface, 'maskedToken' | 'expired'> {
  token: string
}

export interface McpSettingsCreateInterface
  extends Pick<McpSettingsViewInterface, 'name' | 'expiresAt'> {}
